import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

// Renders the Bootstrap dropdown menu with Popper's `fixed` strategy so it
// escapes the clipping of a scrollable ancestor (e.g. a `.table-responsive`).
export default class extends Controller {
  connect() {
    this.toggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
    if (!this.toggle) return

    this.dropdown = new Dropdown(this.toggle, {
      popperConfig: (defaults) => ({ ...defaults, strategy: "fixed" }),
    })
  }

  disconnect() {
    this.dropdown?.dispose()
  }
}
